(function () {
    'use strict';

    CookieService.$inject = ['$cookies'];

    function CookieService($cookies) {
        var option = function () {
            var expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + 1);
            return {
                secure: true,
                'expires': expireDate,
                samesite: 'None'
            };
        };
        this.put = function (key, value) {
            $cookies.put(key, value, option());
        };

        this.get = function (key, defaultValue) {
            var item = $cookies.get(key);
            if (item === undefined && defaultValue !== undefined)
                return defaultValue;
            return item;
        };

        this.putObject = function (key, object) {
            $cookies.putObject(key, object, option());
        };

        this.getObject = function (key, defaultValue) {
            var item = $cookies.getObject(key);
            if (item === undefined && defaultValue !== undefined)
                return defaultValue;
            return item;
        };

        this.remove = function (key) {
            $cookies.remove(key);
        };
    }

    module.exports = CookieService;
})();